import React, { useEffect } from "react";
import { getQuery } from "@/service/http";
import OrderPage from "@/components/buy-deal/deal-order";

/**
 * 订单扫码兑换页面
 *
 */
const Main = () => {
  const { order_id } = getQuery();

  useEffect(() => {
    document
      .querySelector(".ui-headbar")
      .setAttribute("style", "display: none");
    document
      .querySelector(".page-main")
      .setAttribute("style", "padding-top:0px");
  }, []);

  return (
    <div className="h5-order-page">
      <OrderPage orderId={order_id} hasAnimate={false}></OrderPage>
    </div>
  );
};

export default Main;
